import { MenuItem } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { CompanyIdCardsQuery, fetchUserGroupsForCompany } from "../idCardsApi"
import { ImportIdCardsFormValues, UserGroup } from "../idCardsTypes"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"

type SelectUserGroupDropdownProps = Readonly<{}>

export function SelectUserGroupDropdown({}: SelectUserGroupDropdownProps) {
    const { companyId } = useCurrentCompany()

    const { data: userGroups = [] } = useApiQuery(fetchUserGroupsForCompany, {
        queryName: CompanyIdCardsQuery.USER_GROUPS_FOR_COMPANY,
        dependencies: {
            companyId,
        },
        select: (data) => data.userGroups,
    })

    return (
        <LocalizedStrict id="create-or-edit-company-id-cards-field-user-group" attrs={{ label: true }}>
            <FormikDropdown<ImportIdCardsFormValues> fullWidth name="userGroupId" label="User group">
                <MenuItem value={UserGroup.ALL}>
                    <LocalizedStrict id="create-or-edit-company-id-cards-select-item-all">
                        <span>All</span>
                    </LocalizedStrict>
                </MenuItem>
                {userGroups.map((userGroup) => (
                    <MenuItem key={userGroup.id} value={userGroup.id}>
                        {userGroup.name}
                    </MenuItem>
                ))}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
